class FostrAccordion extends MenuDrawer {
  connectedCallback () {
    this.els = {
      summary: this.querySelector('summary'),
      details: this.querySelector('details'),
    }

    this.setEventListeners()
  }

  setEventListeners () {
    this.els.summary.addEventListener('click', this.handleAccordion.bind(this))
  }

  handleAccordion () {
    this.closest('div').querySelectorAll('fostr-accordion').forEach(accordion => {
      if (accordion === this) return

      accordion.querySelector('details').open = false
    })
  }
}

customElements.define('fostr-accordion', FostrAccordion)
